import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { eventsDates, sessionsDates, setSelectedDate, setSelectedMonthDate } from '../../../../../reducers/studentDashboardReducer'
import { ReactComponent as ArrowIcon } from '../../../../../assets/images/common/icons/arrow-right.svg'
import { ReactComponent as ShareIcon } from '../../../../../assets/images/common/icons/share-icon-2.svg'

import ReactCalendar from 'react-calendar'

import 'react-calendar/dist/Calendar.css'
import './Calendar.scss'
import { useState } from 'react'
import CalendarSyncModal from '../../../coachDashboard/CalendarSyncModal'


const Calendar = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()

  const sessions = useSelector(sessionsDates)
  const events = useSelector(eventsDates)
  const selectedDate = useSelector(state => state.studentDashboard.selectedDate)
  const [isCalendarModalOpen, setIsCalendarModalOpen] = useState(false)

  const isSameDay = (a, b) => (
    a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getYear() === b.getYear()
  )

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      if (sessions.find(dDate => isSameDay(dDate, date)) && events.find(dDate => isSameDay(dDate, date))) {
        return <div className='eventAndProgram'>
          <div className='programDate noMargin'/>
          <div className='eventDate noMargin'/>
        </div>
      }
      if (sessions.find(dDate => isSameDay(dDate, date))) {
        return <div className='programDate'/>
      }
      if (events.find(dDate => isSameDay(dDate, date))) {
        return <div className='eventDate'/>
      }
      return <div className='noProgramDate'/>
    }
  }

  return (
    <div className='dashboardCalendarWrapper'>
      <ReactCalendar
        calendarType='gregory'
        locale={i18n.language}
        tileContent={tileContent}
        value={selectedDate}
        onChange={(value) => dispatch(setSelectedDate(value))}
        nextLabel={<ArrowIcon className='nextArrow'/>}
        prevLabel={<ArrowIcon className='prevArrow'/>}
        onActiveStartDateChange={({ activeStartDate }) => dispatch(setSelectedMonthDate(activeStartDate))}
      />

      <div className='footerWrapper'>

        <div className='calendarLegend mr-auto'>
          <div className='legendWrapper'>
            <div className='d-flex align-items-center'>
              <div className='programDate'/>
              <span>{t('dashboard.student.calendar.programsLegend')}</span>
            </div>

            <div className='d-flex align-items-center'>
              <div className='eventDate'/>
              <span>{t('dashboard.student.calendar.eventSeriesLegend')}</span>
            </div>
          </div>
        </div>

        <button onClick={() => setIsCalendarModalOpen(true)}>
          <ShareIcon className='shareIcon' />
          <span>{t('dashboard.student.calendar.share')}</span>
        </button>
        {isCalendarModalOpen && (
          <CalendarSyncModal
            isOpen={isCalendarModalOpen}
            onClose={() => setIsCalendarModalOpen(false)}
            scope={'family'}
          />
        )}
      </div>

    </div>
  )
}

export default Calendar
